// Industries we serve — used on the About page (and available to Home/Services).
// Workflow bullets are drawn from the Automation Workflows deliverables in services.ts,
// mapped to what each vertical actually deals with day to day.

import { IconId } from '../components/icons';

export interface Industry {
  id: string;
  name: string;
  tagline: string;
  workflows: string[];
  icon: IconId;
}

export const INDUSTRIES: Industry[] = [
  {
    id: 'professional-services',
    name: 'Professional Services',
    tagline: 'Accounting, legal, consulting, and agencies — document-heavy, approval-heavy work.',
    workflows: [
      'Invoice, contract, and intake-form extraction into your practice systems',
      'Client onboarding triggered from a single approval',
      'Approvals routed with full context — only true exceptions reach a partner',
    ],
    icon: 'briefcase',
  },
  {
    id: 'nonprofits',
    name: 'Nonprofits & Community Orgs',
    tagline: 'Small teams, tight budgets, and eligibility for special Microsoft licensing.',
    workflows: [
      'Microsoft 365 set up on nonprofit licensing — email, Teams, SharePoint',
      'Donor and volunteer records kept clean across forms and your CRM',
      'Grant reporting assembled on schedule without a spreadsheet marathon',
    ],
    icon: 'heart',
  },
  {
    id: 'manufacturing',
    name: 'Manufacturing, Logistics & Distribution',
    tagline: 'Paper still moves the plant. It doesn’t have to.',
    workflows: [
      'Supplier invoices and POs matched and posted to your ERP without re-keying',
      'Supplier and employee onboarding — accounts, access, paperwork — from one trigger',
      'Finance, ops, and sales systems kept in agreement with scheduled data sync',
    ],
    icon: 'factory',
  },
  {
    id: 'healthcare',
    name: 'Healthcare & Clinics',
    tagline: 'Intake, scheduling, and admin automation with Canadian data residency built in.',
    workflows: [
      'Patient intake and referral forms classified and routed, not retyped',
      'Inbound email and requests triaged with human review on anything sensitive',
      'Self-hosted deployment options that keep data inside Canada',
    ],
    icon: 'stethoscope',
  },
];
